export enum TOSS_CUSTOM_SCHEME {
  TOSSBANK_APP_PREFIX = 'banktoss://',
}
